var map = {
	"./1password-logo.png": "./src/components/Portfolio/PortfolioAbout/components/ChildComponents/Adverts/PartnerLogos/1password-logo.png",
	"./bubble-logo.svg": "./src/components/Portfolio/PortfolioAbout/components/ChildComponents/Adverts/PartnerLogos/bubble-logo.svg",
	"./current-logo.png": "./src/components/Portfolio/PortfolioAbout/components/ChildComponents/Adverts/PartnerLogos/current-logo.png",
	"./freelancer-toolkit-logo.webp": "./src/components/Portfolio/PortfolioAbout/components/ChildComponents/Adverts/PartnerLogos/freelancer-toolkit-logo.webp",
	"./gorilla-logo.png": "./src/components/Portfolio/PortfolioAbout/components/ChildComponents/Adverts/PartnerLogos/gorilla-logo.png",
	"./harvest-logo.png": "./src/components/Portfolio/PortfolioAbout/components/ChildComponents/Adverts/PartnerLogos/harvest-logo.png",
	"./hnry-logo.png": "./src/components/Portfolio/PortfolioAbout/components/ChildComponents/Adverts/PartnerLogos/hnry-logo.png",
	"./honeybook-logo.svg": "./src/components/Portfolio/PortfolioAbout/components/ChildComponents/Adverts/PartnerLogos/honeybook-logo.svg",
	"./intouch-logo.png": "./src/components/Portfolio/PortfolioAbout/components/ChildComponents/Adverts/PartnerLogos/intouch-logo.png",
	"./kerika-logo.svg": "./src/components/Portfolio/PortfolioAbout/components/ChildComponents/Adverts/PartnerLogos/kerika-logo.svg",
	"./kittl-logo.svg": "./src/components/Portfolio/PortfolioAbout/components/ChildComponents/Adverts/PartnerLogos/kittl-logo.svg",
	"./longshot-logo.svg": "./src/components/Portfolio/PortfolioAbout/components/ChildComponents/Adverts/PartnerLogos/longshot-logo.svg",
	"./playground-logo.png": "./src/components/Portfolio/PortfolioAbout/components/ChildComponents/Adverts/PartnerLogos/playground-logo.png",
	"./printful-logo.png": "./src/components/Portfolio/PortfolioAbout/components/ChildComponents/Adverts/PartnerLogos/printful-logo.png",
	"./tldv-logo.png": "./src/components/Portfolio/PortfolioAbout/components/ChildComponents/Adverts/PartnerLogos/tldv-logo.png",
	"./undock-logo.webp": "./src/components/Portfolio/PortfolioAbout/components/ChildComponents/Adverts/PartnerLogos/undock-logo.webp",
	"./wetransfer-logo.png": "./src/components/Portfolio/PortfolioAbout/components/ChildComponents/Adverts/PartnerLogos/wetransfer-logo.png",
	"./wix-logo-ff.svg": "./src/components/Portfolio/PortfolioAbout/components/ChildComponents/Adverts/PartnerLogos/wix-logo-ff.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/components/Portfolio/PortfolioAbout/components/ChildComponents/Adverts/PartnerLogos sync recursive ^\\.\\/.*$";